import * as React from 'react';
import { isMailUrl } from '../../../../utils/locationUtils';
import { Text } from '../Text/index';

export const ExternalLink = ({
  to = '',
  dataHook = 'external-link',
  children,
  ...restOfProps
}) => {
  const shouldOpenInSameTab = isMailUrl(to);
  return (
    <Text
      tagName="a"
      link
      dataHook={dataHook}
      href={to}
      target={restOfProps.target || shouldOpenInSameTab ? '_self' : '_blank'}
      rel="noopener noreferrer"
      {...restOfProps}
    >
      {children}
    </Text>
  );
};
